import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import HeaderMenu from '../components/header/HeaderMenu'
import NotifierComponent from '../components/notifier/NotifierComponent'
import '../utils/testMobile'
import cx from 'classnames'

const MainLayout = (props) => {
	const ua = navigator.userAgent
	const isIE = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
	return (
		<div>
			<HeaderMenu {...props} />
			<section className={cx('main-content', { 'main-content--ie': isIE })}>
				{props.children}
			</section>
			<NotifierComponent />
		</div>
	)
}

MainLayout.propTypes = {
	children: PropTypes.element.isRequired
}

export default MainLayout



// WEBPACK FOOTER //
// ./src/containers/MainLayout.js